export { default as icannTrie } from "../serialized-tries/icann.js";
export { default as privateTrie } from "../serialized-tries/private.js";
